import { usePayoutResultSelectOptions } from "components/UI/Selects/PayoutResultSelectSearchable/usePayoutResultSelectOptions.ts";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

interface PayoutResultSelectSearchableProps extends SearchableSelectWrapperProps {
    /** Include empty option at the beginning */
    withEmptyOption?: boolean;
}

export const PayoutResultSelectSearchable = (props: PayoutResultSelectSearchableProps) => {
    const { withEmptyOption, ...restProps } = props;
    const hookResult = usePayoutResultSelectOptions({ withEmptyOption });

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.payout_result"
            {...restProps}
            size={props.size ?? "middle"}
        />
    );
};
